import {
  FilterCategoryModel,
  FilterItemModel,
} from "@/models/filterItem.model";
import { KioskModel } from "@/models/kiosk.model";
import Cafe from "@/assets/cafés.svg";
import Fashion from "@/assets/fashion.svg";
import ATM from "@/assets/atm.svg";
import BeautyWellness from "@/assets/beauty_&_wellness.svg";
import BooksStationery from "@/assets/books_&_stationery.svg";
import Bus from "@/assets/bus.svg";
import CustomerServiceDesk from "@/assets/info.svg";
import Desserts from "@/assets/confectionary.svg";
import Entrance from "@/assets/entrance.svg";
import FastFood from "@/assets/fast_food.svg";
import GiftCard from "@/assets/gift_cards.svg";
import HandsFreeService from "@/assets/hands_free.svg";
import HomeTech from "@/assets/home&tech.svg";
import Hypermarket from "@/assets/hypermarkets.svg";
import JewelleryWatches from "@/assets/jewellery_&_watches.svg";
import Kids from "@/assets/kids_&_maternity.svg";
import LostFound from "@/assets/box.svg";
// import LuggageBagDrop from '@/assets/luggage_bag_drop.svg';
import Luxury from "@/assets/luxury.svg";
import MallManager from "@/assets/manager.svg";
import OpticsEyewear from "@/assets/optics_&_eyewear.svg";
import Parking from "@/assets/parking.svg";
import PrayerRoomMale from "@/assets/prayer_room_female.svg";
import PrayerRoomFemale from "@/assets/prayer_room_male.svg";
import RedCrescent from "@/assets/charity.svg";
import Restaurant from "@/assets/restaurant.svg";
import RestroomFemale from "@/assets/female.svg";
import RestroomMale from "@/assets/men.svg";
import Services from "@/assets/services.svg";
import SpecialtyFood from "@/assets/specialty_copy.svg";
import SpecialtyShop from "@/assets/specialty_shop2.svg";
import SportsLeisure from "@/assets/sports_&_leisure.svg";
import Taxi from "@/assets/taxi.svg";
import ToysGames from "@/assets/toys_&_games.svg";
import UberCareem from "@/assets/uber.svg";
import ValetParking from "@/assets/valet.svg";
import Wifi from "@/assets/wifi.svg";
import Share from "@/assets/coin.svg";
import Stroller from "@/assets/stroller.svg";
import Wheelchair from "@/assets/wheelchair.svg";
import BabyChangingFemale from "@/assets/changing.svg";
import BabyChangingMale from "@/assets/changing-1.svg";
import ParkingAssist from "@/assets/park_assist.svg";
import FirstAid from "@/assets/first_aid.svg";
import AccessibleParking from "@/assets/accessible-parking.svg";
import FemaleAccessibleToilet from "@/assets/accessible-toilet-F.svg";
import MaleAccessibleToilet from "@/assets/accessible-toilet-M.svg";
import FamilyParking from "@/assets/family-parking.svg";
import SuvParking from "@/assets/SUV-parking.svg";
import BabyFeeding from "@/assets/baby-feeding.svg";
import Hotel from "@/assets/hotel-solid.svg";
import HotelWhite from "@/assets/hotel-solid-white.svg";
import Facilities from "@/assets/facilities-ultra.svg";
import FacilitiesWhite from "@/assets/facilities-ultra-white.svg";
import { FaBagShopping, FaFaceSmile, FaUtensils } from "react-icons/fa6";
import { AmenityModel } from "proximiio-js-library/lib/models/amenity";
import Feature from "proximiio-js-library/lib/models/feature";
import Entertainment from "@/assets/entertainment.svg";
import iFly from "@/assets/ifly.svg";
import LittleExplorers from "@/assets/little-explorers.svg";
import MagicPlanet from "@/assets/magic-planet.svg";
import Snow from "@/assets/snow.svg";
import VoxCinema from "@/assets/vox-cinema.svg";

export const getListAsClosest = () => {
  const closestList = [];
  for (const category of filterCategories) {
    closestList.push(category.items.filter((item) => item.listAsClosest));
  }
  return closestList.flat(2);
};

export const getHiddenItems = () => {
  const list = [];
  for (const category of filterCategories) {
    for (const item of category.items.filter((item) => item.hideMapIcon)) {
      list.push(item.id);
    }
  }
  return list.flat(2);
};

export const getExcludedItems = () => {
  const list = [];
  for (const category of filterCategories) {
    for (const item of category.items.filter(
      (item) => item.excludeFromSearch,
    )) {
      list.push(item.id);
    }
  }
  return list.flat(2);
};

export const getHiddenUntilSelectedItems = () => {
  const list = [];
  for (const category of filterCategories) {
    for (const item of category.items.filter(
      (item) => item.hideIconUntilSelected,
    )) {
      list.push(item.id);
    }
  }
  return list.flat();
};

export const filterCategories: FilterCategoryModel[] = [
  {
    title: "shop",
    id: "shop",
    color: "185.6,100%,41.8%",
    icon: FaBagShopping,
    items: [
      {
        title: "fashion",
        iconImage: Fashion,
        id: [
          "75698d35-0918-4a2b-a8ab-77b93a618e61:c302b098-4c76-4a70-ae7c-5a0349e86fda",
          "75698d35-0918-4a2b-a8ab-77b93a618e61:9fdc16b9-6d74-41e2-8453-197a28242906",
          "75698d35-0918-4a2b-a8ab-77b93a618e61:cfd608b1-fe61-4bea-92db-82a848452a45",
          "75698d35-0918-4a2b-a8ab-77b93a618e61:318ed8dc-72ac-4bd6-bb07-22842a9dbe46",
          "75698d35-0918-4a2b-a8ab-77b93a618e61:b156c461-815a-4b31-b99d-9a49c75d6783",
          "75698d35-0918-4a2b-a8ab-77b93a618e61:f480f5f2-f5b7-4944-9e3d-c4baf78e490e",
          "75698d35-0918-4a2b-a8ab-77b93a618e61:a134605e-fe37-4845-92d0-2cf09333b04e",
          "75698d35-0918-4a2b-a8ab-77b93a618e61:8a12fbd5-ebb5-4d95-b9e1-3acd28443c9d",
          "75698d35-0918-4a2b-a8ab-77b93a618e61:0a7e293f-750c-499a-8308-91bc253612ef",
          "75698d35-0918-4a2b-a8ab-77b93a618e61:d266e799-49a5-49c7-a37a-0426feaabb13",
          "75698d35-0918-4a2b-a8ab-77b93a618e61:02c3ff3a-f21e-4acc-a193-33f4eec3c80e",
          "75698d35-0918-4a2b-a8ab-77b93a618e61:762bcc6b-34f4-43c2-9c5a-0c8748d0656b",
          "75698d35-0918-4a2b-a8ab-77b93a618e61:0fa149b7-aa6f-42ac-8c8d-7ceae2a96266",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "sport-leisure",
        iconImage: SportsLeisure,
        id: [
          "75698d35-0918-4a2b-a8ab-77b93a618e61:ee26e3bc-4911-4843-803b-d109e6f57742",
          "75698d35-0918-4a2b-a8ab-77b93a618e61:9b579881-7911-4950-9146-504f270ccbed",
          "75698d35-0918-4a2b-a8ab-77b93a618e61:03a45c5d-fb77-43bb-81e2-c6a61868aae8",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "premium",
        iconImage: Luxury,
        id: "75698d35-0918-4a2b-a8ab-77b93a618e61:53590614-9aa0-4afa-8b8b-cfa3136b316e",
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "kids-maternity",
        iconImage: Kids,
        id: "75698d35-0918-4a2b-a8ab-77b93a618e61:7dcc5aba-633a-402a-adb7-9e9c877b053c",
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "home-tech",
        iconImage: HomeTech,
        id: [
          "75698d35-0918-4a2b-a8ab-77b93a618e61:39a12b78-31a1-4d54-92b9-b117e6d7ab38",
          "75698d35-0918-4a2b-a8ab-77b93a618e61:c078687b-c3df-4add-9b30-c0ac4e0af53a",
          "75698d35-0918-4a2b-a8ab-77b93a618e61:6f4db4db-5c96-4414-a3da-bbc79a23e773",
          "75698d35-0918-4a2b-a8ab-77b93a618e61:a4a01be9-70cf-4a32-9b15-b693214009aa",
          "75698d35-0918-4a2b-a8ab-77b93a618e61:abf57b7c-7216-4ade-bd30-e035bd2caa91",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "beauty-wellness",
        iconImage: BeautyWellness,
        id: [
          "75698d35-0918-4a2b-a8ab-77b93a618e61:d812b45f-5257-4a50-ac08-1e2b4d269116",
          "75698d35-0918-4a2b-a8ab-77b93a618e61:43b3fe55-f30e-4e5c-a0d5-b17994b45425",
          "75698d35-0918-4a2b-a8ab-77b93a618e61:93e2af3a-af5f-4e33-b8be-e9d0612afb36",
          "75698d35-0918-4a2b-a8ab-77b93a618e61:dd55ddd1-bff7-4897-8b54-ea31cda687ae",
          "75698d35-0918-4a2b-a8ab-77b93a618e61:1b4e2f00-15d3-4d44-8b44-586150ccbcb0",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "jewellery-watches",
        iconImage: JewelleryWatches,
        id: "75698d35-0918-4a2b-a8ab-77b93a618e61:7c7a6e4d-9a5c-44d6-b9ac-298d606ce126",
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "books-stationery",
        iconImage: BooksStationery,
        id: "75698d35-0918-4a2b-a8ab-77b93a618e61:b87bc5ce-def9-4a62-a78a-a38b7ac787a6",
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "toys-games",
        iconImage: ToysGames,
        id: [
          "75698d35-0918-4a2b-a8ab-77b93a618e61:1609bf66-4dba-46e4-aaed-5e7b92dc0c65",
          "75698d35-0918-4a2b-a8ab-77b93a618e61:ecf63da4-81af-45bf-9450-80eadcc395a5",
          "75698d35-0918-4a2b-a8ab-77b93a618e61:93d07ff1-c0ab-4152-b9e0-a662990cfa47",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "optics-eyewear",
        iconImage: OpticsEyewear,
        id: "75698d35-0918-4a2b-a8ab-77b93a618e61:28d180c2-1d18-4b07-bf4d-3646314b7c80",
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "speciality",
        iconImage: SpecialtyShop,
        id: [
          "75698d35-0918-4a2b-a8ab-77b93a618e61:35c7c2a2-e703-4f17-9be0-a437fe3a6b9b",
          "75698d35-0918-4a2b-a8ab-77b93a618e61:5e8bc3fa-26f4-4665-8d40-24dce81fd1f8",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "services",
        iconImage: Services,
        id: "75698d35-0918-4a2b-a8ab-77b93a618e61:c17f3734-b854-4b92-b760-02602c7e2d75",
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "hypermarket",
        iconImage: Hypermarket,
        id: [
          "75698d35-0918-4a2b-a8ab-77b93a618e61:632f91c3-ce20-4466-b5f5-96da4e0905bc",
          "75698d35-0918-4a2b-a8ab-77b93a618e61:d45449cb-1fa9-473f-a1d5-b7c2077b1cf5",
        ],
        type: "list",
        hideMapIcon: true,
      },
    ],
  },
  {
    title: "dine",
    id: "dine",
    color: "10.6,100%,61.2%",
    icon: FaUtensils,
    items: [
      {
        title: "desserts",
        iconImage: Desserts,
        id: "75698d35-0918-4a2b-a8ab-77b93a618e61:a5286ad2-527f-4bfd-a1c1-3cb13161fe69",
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "cafes",
        iconImage: Cafe,
        id: [
          "75698d35-0918-4a2b-a8ab-77b93a618e61:091f4137-6ca6-436c-ab04-20a5e964568f",
          "75698d35-0918-4a2b-a8ab-77b93a618e61:6e11302a-65df-4497-81dc-d7572486f911",
          "75698d35-0918-4a2b-a8ab-77b93a618e61:4add7c35-f7bd-4f96-b268-5eddef2b126b",
          "75698d35-0918-4a2b-a8ab-77b93a618e61:62bba064-81e3-4d87-a5a7-2d0300d2a105",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "fast-food",
        iconImage: FastFood,
        id: [
          "75698d35-0918-4a2b-a8ab-77b93a618e61:276391e6-6dfa-413a-8e6a-3276bfa673d0",
          "75698d35-0918-4a2b-a8ab-77b93a618e61:89df401a-e85b-4c17-8132-9011eefc9175",
        ],
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "restaurants",
        iconImage: Restaurant,
        id: "75698d35-0918-4a2b-a8ab-77b93a618e61:15b182b8-9307-4185-8403-37858c557c63",
        type: "list",
        hideMapIcon: true,
      },
      {
        title: "specialty-food",
        iconImage: SpecialtyFood,
        id: "75698d35-0918-4a2b-a8ab-77b93a618e61:2c3032ca-9e44-42b6-b9f7-0c1b556ac2e4",
        type: "list",
        hideMapIcon: true,
      },
    ],
  },
  {
    title: "entertainment",
    id: "entertainment",
    color: "284.4,100%,38.4%",
    icon: FaFaceSmile,
    items: [],
  },
  {
    title: "hotels",
    id: "hotels",
    color: "208,100%,33%",
    iconImage: Hotel,
    iconImageAlt: HotelWhite,
    listed: false,
    items: [
      {
        title: "female-prayer-room",
        iconImage: PrayerRoomFemale,
        id: "75698d35-0918-4a2b-a8ab-77b93a618e61:48ffe5fa-1706-4600-860f-ed6d64e73a2e",
        type: "list",
        hideMapIcon: true,
      },
    ],
  },
  {
    title: "facilities",
    id: "facilities",
    color: "40.6,99%,61.4%",
    iconImage: Facilities,
    iconImageAlt: FacilitiesWhite,
    items: [
      {
        title: "female-prayer-room",
        iconImage: PrayerRoomFemale,
        id: "75698d35-0918-4a2b-a8ab-77b93a618e61:48ffe5fa-1706-4600-860f-ed6d64e73a2e",
        type: "list",
        hideIconUntilSelected: false,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "male-prayer-room",
        iconImage: PrayerRoomMale,
        id: "75698d35-0918-4a2b-a8ab-77b93a618e61:f9350ac5-a932-4483-8a79-29d177245fc5",
        type: "list",
        hideIconUntilSelected: false,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "female-toilet",
        iconImage: RestroomFemale,
        id: "75698d35-0918-4a2b-a8ab-77b93a618e61:3574e57c-1ecf-47d5-b8f3-b9de1c39cf1b",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        hideMapIcon: false,
      },
      {
        title: "male-toilet",
        iconImage: RestroomMale,
        id: "75698d35-0918-4a2b-a8ab-77b93a618e61:2a5b339e-30da-4186-9749-06906731b8c9",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        hideMapIcon: false,
      },
      {
        title: "atm",
        iconImage: ATM,
        id: "75698d35-0918-4a2b-a8ab-77b93a618e61:9c925821-744a-41c4-92cb-0342ab4c2ef9",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "customer-service-desk",
        iconImage: CustomerServiceDesk,
        id: "75698d35-0918-4a2b-a8ab-77b93a618e61:46462707-8567-4684-a808-5ad3410e49ee",
        type: "closest",
        hideIconUntilSelected: false,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "baby-care-room",
        iconImage: BabyFeeding,
        id: "75698d35-0918-4a2b-a8ab-77b93a618e61:b80735fd-92a0-419c-80e7-495040bfc515",
        type: "closest",
        hideIconUntilSelected: true,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "baby-changing-room-female",
        iconImage: BabyChangingFemale,
        id: "75698d35-0918-4a2b-a8ab-77b93a618e61:3574e57c-1ecf-47d5-b8f3-b9de1c39cf1b",
        type: "closest",
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "baby-changing-room-male",
        iconImage: BabyChangingMale,
        id: "75698d35-0918-4a2b-a8ab-77b93a618e61:2a5b339e-30da-4186-9749-06906731b8c9",
        type: "closest",
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "female-accessible-toilet",
        iconImage: FemaleAccessibleToilet,
        id: "75698d35-0918-4a2b-a8ab-77b93a618e61:3574e57c-1ecf-47d5-b8f3-b9de1c39cf1b",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        hideMapIcon: false,
      },
      {
        title: "male-accessible-toilet",
        iconImage: MaleAccessibleToilet,
        id: "75698d35-0918-4a2b-a8ab-77b93a618e61:2a5b339e-30da-4186-9749-06906731b8c9",
        type: "closest",
        listAsClosest: true,
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        hideMapIcon: false,
      },
      {
        title: "taxi-stand",
        iconImage: Taxi,
        id: "75698d35-0918-4a2b-a8ab-77b93a618e61:e835e573-36a6-47e2-9687-4ac05c6cd717",
        type: "list",
        hideIconUntilSelected: false,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "uber-careem",
        iconImage: UberCareem,
        id: "75698d35-0918-4a2b-a8ab-77b93a618e61:0a0e1fee-8f1f-4daf-a052-6b6781e73e53",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "bus-stop",
        iconImage: Bus,
        id: "75698d35-0918-4a2b-a8ab-77b93a618e61:ceecefbf-f9b0-47fb-ba53-694e2f120b6c",
        type: "list",
        hideIconUntilSelected: false,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "entrance",
        iconImage: Entrance,
        id: "75698d35-0918-4a2b-a8ab-77b93a618e61:d3b90466-cb7e-41f6-b66b-f1edb872dae7",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "parking",
        iconImage: Parking,
        id: "75698d35-0918-4a2b-a8ab-77b93a618e61:21a6d59b-fe0d-46ff-890e-477577d592f7",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "valet-parking",
        iconImage: ValetParking,
        id: "75698d35-0918-4a2b-a8ab-77b93a618e61:145c91c9-bf64-41d6-8933-62e062204ebd",
        type: "list",
        excludeFromSearch: false,
        hideIconUntilSelected: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "pod-parking",
        iconImage: AccessibleParking,
        id: "75698d35-0918-4a2b-a8ab-77b93a618e61:93cf06a6-8ae5-4e96-a41b-f28e414e7536",
        type: "list",
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "family-parking",
        iconImage: FamilyParking,
        id: "75698d35-0918-4a2b-a8ab-77b93a618e61:c102ebb0-1010-41ad-b9d3-5257d68f23a3",
        type: "list",
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "suv-parking",
        iconImage: SuvParking,
        id: "75698d35-0918-4a2b-a8ab-77b93a618e61:b0f722ff-8545-4450-9745-c4a23c9f20aa",
        type: "list",
        excludeFromSearch: true,
        hideIconUntilSelected: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "find-my-car-kiosk",
        iconImage: ParkingAssist,
        id: "75698d35-0918-4a2b-a8ab-77b93a618e61:4595998f-e855-4308-b68a-d9de1b1022b1",
        type: "list",
        excludeFromSearch: true,
        hideIconUntilSelected: true,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "charity",
        iconImage: RedCrescent,
        id: "75698d35-0918-4a2b-a8ab-77b93a618e61:129adad3-86b0-4e98-94de-736eea1addc4",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "hands-free-service",
        iconImage: HandsFreeService,
        id: "75698d35-0918-4a2b-a8ab-77b93a618e61:d09ca7c2-8e7e-482d-86eb-f9cb59ee3f2b",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "lost-found",
        iconImage: LostFound,
        id: "75698d35-0918-4a2b-a8ab-77b93a618e61:6db7ba2d-086b-42e7-b639-627e122df991",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "first-aid",
        iconImage: FirstAid,
        id: "75698d35-0918-4a2b-a8ab-77b93a618e61:190b69bf-0ef9-416d-aa6b-53f4dd061064",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "wheelchairs",
        iconImage: Wheelchair,
        id: "75698d35-0918-4a2b-a8ab-77b93a618e61:b1fd76f5-1cd6-47e3-83a6-52188d2685ec",
        type: "closest",
        hideIconUntilSelected: true,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "baby-strollers",
        iconImage: Stroller,
        id: "75698d35-0918-4a2b-a8ab-77b93a618e61:1840e949-9695-43b6-8b8d-20cab4faaad8",
        type: "closest",
        hideIconUntilSelected: true,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "gift-card",
        iconImage: GiftCard,
        id: "75698d35-0918-4a2b-a8ab-77b93a618e61:46462707-8567-4684-a808-5ad3410e49ee",
        type: "closest",
        hideIconUntilSelected: false,
        excludeFromSearch: true,
        listed: true,
        listAsClosest: true,
        hideMapIcon: false,
      },
      {
        title: "mall-management-office",
        iconImage: MallManager,
        id: "75698d35-0918-4a2b-a8ab-77b93a618e61:71193cff-fa23-4751-9495-8c540d3b1c1a",
        type: "list",
        hideIconUntilSelected: true,
        excludeFromSearch: false,
        listed: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "parking-bays",
        id: [
          "75698d35-0918-4a2b-a8ab-77b93a618e61:e9ee65a1-1573-46de-8eaa-8b9a6b6eec76",
          "75698d35-0918-4a2b-a8ab-77b93a618e61:9fa0659c-e16e-46bd-8dfa-09720cbb4892",
          "75698d35-0918-4a2b-a8ab-77b93a618e61:e25a728c-10f7-4488-8ae6-f3ed24a01160",
          "75698d35-0918-4a2b-a8ab-77b93a618e61:533718fe-2628-4488-b430-3aa2b9a590e4",
          "75698d35-0918-4a2b-a8ab-77b93a618e61:754624eb-7a0f-4043-847a-09218c1b1c2b",
          "75698d35-0918-4a2b-a8ab-77b93a618e61:9272082d-954b-456f-a0d1-38faab399bce",
          "75698d35-0918-4a2b-a8ab-77b93a618e61:a4bad218-5d2d-4797-a6a6-829e75bc6f7d",
          "75698d35-0918-4a2b-a8ab-77b93a618e61:7e0d8347-0c41-4c36-9815-083aee46faa4",
        ],
        type: "list",
        listed: false,
        hideIconUntilSelected: true,
        excludeFromSearch: true,
        listAsClosest: false,
        hideMapIcon: false,
      },
      {
        title: "vacant",
        id: [
          "75698d35-0918-4a2b-a8ab-77b93a618e61:4aff8aa8-0231-4215-a1fe-d9ca3dffd2ce",
        ],
        type: "list",
        listed: false,
        hideMapIcon: true,
        excludeFromSearch: true,
        hideIconUntilSelected: true,
        listAsClosest: false,
      },
      {
        title: "others",
        id: [
          "75698d35-0918-4a2b-a8ab-77b93a618e61:ed5bcc63-ffd2-486a-a421-7893840a4150",
          "75698d35-0918-4a2b-a8ab-77b93a618e61:fc57bc52-fd47-46fa-8a50-6cd8be17c551",
          "75698d35-0918-4a2b-a8ab-77b93a618e61:00e42e4b-247b-4f99-b77c-08b393975a20",
          "75698d35-0918-4a2b-a8ab-77b93a618e61:24706473-cf4b-4b5e-a6c7-7750d0236126",
          "75698d35-0918-4a2b-a8ab-77b93a618e61:cd0d9abe-7461-4018-9615-7b665e46c9eb",
        ],
        type: "list",
        listed: false,
        hideMapIcon: true,
        excludeFromSearch: false,
        hideIconUntilSelected: true,
        listAsClosest: false,
      },
      {
        title: "notlistedbuttobehide",
        id: [],
        type: "list",
        listed: false,
      },
      {
        title: "wifi",
        iconImage: Wifi,
        type: "info",
        listed: false,
        content: {
          en: `
						<h3 class="text-xl font-bold my-4">#Free_ Mall_WiFi</h3>
						<p class="font-bold mb-4">We Understand that staying connected is important in today’s world. That’s why we’re excited to offer #Free_ Mall_WiFi to all our shoppers.</p>
						<ul class="mb-4">
							<li>1. Please choose #Free_Mall_WiFi from the list of Wi-Fi networks.</li>
							<li>2. Your device should automatically be taken to our login page.</li>
							<li>3. Enter your details and follow the instructions to gain high-speed internet service.</li>
						</ul>
					`,
          ar: `
						<h3 class="text-xl font-bold my-4">#Free_ Mall_WiFi</h3>
						<p class="font-bold mb-4">نحن نتفهم أن البقاء على اتصال أمر مهم في عالم اليوم.لهذا السبب نحن متحمسون لتقديم خدمة فري وايفاي لجميع المتسوقين لدينا</p>
						<ul>
							<li>من قائمة الشبكات #Free_Mall_WiFi الرجاء اختيار</li>
							<li>يجب أن يتم نقل جهازك تلقائيا إلى صفحة تسجيل الدخول الخاصة بنا</li>
							<li>أدخل بياناتك واتبع التعليمات للحصول على خدمة إنترنت عالي السرعة</li>
						</ul>
					`,
        },
      },
      {
        title: "share",
        iconImage: Share,
        type: "info",
        listed: false,
        content: {
          en: `
						<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary mt-4 block text-lg font-semibold">Join SHARE</a>
						<h3 class="text-2xl font-bold mb-6">Get More At City Centre Mirdif</h3>
						<p class="mb-6">As a member of the SHARE rewards programme, you get cash back in points at all stores and restaurants in City Centre Mirdif and beyond. Join the SHARE programme now – it’s free and will only take you a few minutes.</p>
						<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary text-lg font-semibold">Join SHARE Rewards</a>
					`,
          ar: `
					<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary mt-4 block text-lg font-semibold">سجلوا في تطبيق شير</a>
					<h3 class="text-2xl font-bold mb-6">احصلوا على المزيد في سيتي سنتر مردف</h3>
					<p class="mb-6">تخولكم عضويتكم في برنامج المكافآت شير استرداد بعض النقود في صورة نقاط لدى جميع المتاجر والمطاعم في سيتي سنتر مردف وأماكن أخرى خارج المول. انضموا إلى برنامج المكافآت شير الآن - فهو مجاني ولا يلزم لانضمامكم إليه سوى دقائق معدودة.</p>
					<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary text-lg font-semibold">سجلوا في تطبيق شير</a>
					`,
        },
      },
    ],
  },
];

filterCategories.push({
  title: "hidden",
  id: "hidden",
  listed: false,
  items: [
    {
      title: "hidden",
      id: getHiddenUntilSelectedItems() as string[],
      type: "list",
      listed: false,
    },
  ],
});

export const kiosks: KioskModel[] = [
  {
    name: "kiosk",
    latitude: 25.21620020891565,
    longitude: 55.40792571152656,
    level: 0,
    pitch: 40,
    bearing: 10,
    zoom: 18,
    poiId:
      "75698d35-0918-4a2b-a8ab-77b93a618e61:c2f3d327-d2ee-4d6f-a14f-2a85dfb1ab8d",
  },
];

export const excludedAmenities: string[] = getExcludedItems() as string[];

// Function to build additional filters based on amenities and features
export const buildAdditionalFilters = ({
  amenities,
  features,
  language,
}: {
  amenities: AmenityModel[] | null;
  features: Feature[] | null;
  language: string;
}): FilterItemModel[] | void => {
  // Early exit if amenities or features are missing
  if (!amenities) {
    console.error("amenities is null");
    return;
  }

  if (!features) {
    console.error("features is null");
    return;
  }

  // Define amenity titles and their mapping to ids/features
  const amenityMapping: {
    [key: string]: {
      amenity?: AmenityModel;
      features: Feature[];
      icon: string;
    };
  } = {
    "Snow/Ski": { amenity: undefined, features: [], icon: Snow },
    "Vox Cinema": { amenity: undefined, features: [], icon: VoxCinema },
    "Magic Planet": { amenity: undefined, features: [], icon: MagicPlanet },
    iFLY: { amenity: undefined, features: [], icon: iFly },
    "Little Explorers": {
      amenity: undefined,
      features: [],
      icon: LittleExplorers,
    },
    Entertainment: { amenity: undefined, features: [], icon: Entertainment },
  };

  // Map amenities to their respective amenity titles
  for (const amenity of amenities) {
    if (amenityMapping[amenity.title]) {
      amenityMapping[amenity.title].amenity = amenity;
    }
  }

  // Map features to their respective amenities
  for (const feature of features) {
    for (const key in amenityMapping) {
      const { amenity } = amenityMapping[key];
      if (feature.properties?.amenity === amenity?.id) {
        amenityMapping[key].features.push(feature);
      }
    }
  }

  // Utility function to retrieve a translated title
  const getTranslatedTitle = (feature: Feature): string => {
    const { title_i18n, title } = feature.properties || {};
    return title_i18n?.[language] || title_i18n?.en || title;
  };

  const items: FilterItemModel[] = [];

  // Create filter items for each amenity based on available features
  for (const key in amenityMapping) {
    const { amenity, features, icon } = amenityMapping[key];

    if (amenity && features.length > 0) {
      let itemTitle: string | undefined;

      // If there is only one feature, use the feature title
      if (features.length === 1) {
        itemTitle = getTranslatedTitle(features[0]);
      }

      // Set up the item object for the filter list
      const baseItem: FilterItemModel = {
        title: key.toLowerCase().replace(/\s/g, "-"), // Convert title to kebab-case
        translatedTitle: itemTitle,
        iconImage: icon,
        id: [amenity.id],
        hideMapIcon: true,
        type: "list",
      };

      // Push items to the list based on the type (list or single)
      if (key === "Entertainment") {
        // For "Entertainment", push individual features
        features.forEach((feature) => {
          items.push({
            ...baseItem,
            type: "single",
            title: getTranslatedTitle(feature)
              .toLowerCase()
              .replace(/\s/g, "-"), // Convert title to kebab-case
            translatedTitle: getTranslatedTitle(feature),
            featureId: feature.id,
          });
        });
      } else {
        // For other amenities, push as a list
        items.push(baseItem);
      }
    }
  }

  const entertainmentIndex = filterCategories.findIndex(
    (category) => category.id === "entertainment",
  );
  filterCategories[entertainmentIndex].items = items;
};
